import { z } from "zod";

export const machineSecurePrintConfiguration = z.object({
	delayLabelRetrieval: z.boolean(),
});
